import { CoreFieldInfoLang } from "@aipb/gulliver/castor/model";
import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { Observable } from 'rxjs';

interface FieldProps {
  [coreId: string]: {
    search: CoreFieldInfoLang[];
    sort: CoreFieldInfoLang[];
    visible: CoreFieldInfoLang[];
    register: CoreFieldInfoLang[];
  };
}

const store = createStore({ name: 'castor-field' }, withProps<FieldProps>({}));

@Injectable({
  providedIn: 'root'
})
export class FieldRepository {
  select() {
    return store.pipe(select((state) => state));
  }

  public getSearchFields(coreId: string): CoreFieldInfoLang[] {
    return this.getFields(coreId, 'search');
  }

  getSearchField(coreId: string, fieldId: string): CoreFieldInfoLang | undefined {
    return this.getSearchFields(coreId).find((f) => f.fieldId === fieldId);
  }

  public getVisibleFields(coreId: string): CoreFieldInfoLang[] {
    return this.getFields(coreId, 'visible');
  }

  getVisibleField(coreId: string, fieldId: string): CoreFieldInfoLang | undefined {
    return this.getVisibleFields(coreId).find((f) => f.fieldId === fieldId);
  }

  public getSortFields(coreId: string): CoreFieldInfoLang[] {
    return this.getFields(coreId, 'sort');
  }

  getSortField(coreId: string, fieldId: string): CoreFieldInfoLang | undefined {
    return this.getSortFields(coreId).find((f) => f.fieldId === fieldId);
  }

  public getRegisterFields(coreId: string): CoreFieldInfoLang[] {
    return this.getFields(coreId, 'register');
  }

  getRegisterField(coreId: string, fieldId: string): CoreFieldInfoLang | undefined {
    return this.getRegisterFields(coreId).find((f) => f.fieldId === fieldId);
  }

  selectRegister(coreId: string): Observable<CoreFieldInfoLang[]> {
    return store.pipe(
      select((state) => {
        return coreId in state ? state[coreId].register : [];
      })
    );
  }

  public setFields(coreId: string, fields: FieldProps['']) {
    store.update((state) => ({
      ...state,
      [coreId]: fields
    }));
  }

  reset() {
    store.reset();
  }

  private getFields(coreId: string, fieldType: keyof FieldProps['']): CoreFieldInfoLang[] {
    if (!(coreId in store.getValue())) return [];

    return store.getValue()[coreId][fieldType];
  }
}
